export const firebaseConfig = {
  apiKey: "AIzaSyCJoOFfmbdMZ0foIi6DcWHtgQQnSPXCtS0",
  authDomain: "michaeljackson-work.firebaseapp.com",
  projectId: "michaeljackson-work",
  storageBucket: "michaeljackson-work.appspot.com",
  messagingSenderId: "92527388125",
  appId: "1:92527388125:web:3401d5e9ad4ff1c5afc234"
};
